import React from "react";

const SubscriptionIcon = (props: any) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.183 9.78906H13.333C12.9913 9.78906 12.708 9.50573 12.708 9.16406V3.33906C12.708 2.72239 12.9497 2.1474 13.383 1.71406C13.8163 1.28073 14.3913 1.03906 15.008 1.03906H15.0163C16.058 1.0474 17.0413 1.45573 17.7913 2.1974C18.5413 2.95573 18.9497 3.95573 18.9497 4.9974V7.01406C18.958 8.67239 17.8413 9.78906 16.183 9.78906ZM13.958 8.53906H16.183C17.1497 8.53906 17.708 7.98073 17.708 7.01406V4.9974C17.708 4.28073 17.4247 3.5974 16.9163 3.08073C16.408 2.58073 15.7247 2.2974 15.0163 2.28906C15.0163 2.28906 15.0163 2.28906 15.008 2.28906C14.733 2.28906 14.4663 2.39739 14.2663 2.59739C14.0663 2.79739 13.958 3.05573 13.958 3.33906V8.53906Z"
        fill="#1678F2"
      />
      <path
        d="M7.50033 19.4391C7.10866 19.4391 6.74199 19.2891 6.46699 19.0057L5.08366 17.6141C5.00866 17.5391 4.89199 17.5307 4.80866 17.5974L3.37533 18.6641C2.93366 18.9974 2.35033 19.0557 1.85033 18.8057C1.35033 18.5557 1.04199 18.0557 1.04199 17.4974V4.9974C1.04199 2.48073 2.48366 1.03906 5.00033 1.03906H15.0003C15.342 1.03906 15.6253 1.3224 15.6253 1.66406C15.6253 2.00573 15.342 2.28906 15.0003 2.28906C14.4253 2.28906 13.9587 2.75573 13.9587 3.33073V17.4974C13.9587 18.0557 13.6503 18.5557 13.1503 18.8057C12.6503 19.0557 12.067 19.0057 11.6253 18.6724L10.2003 17.6057C10.117 17.5391 10.0003 17.5557 9.93366 17.6224L8.53366 19.0224C8.25866 19.2891 7.89199 19.4391 7.50033 19.4391ZM4.92533 16.3057C5.30866 16.3057 5.68366 16.4474 5.96699 16.7391L7.35033 18.1307C7.40033 18.1807 7.46699 18.1891 7.50033 18.1891C7.53366 18.1891 7.60033 18.1807 7.65033 18.1307L9.05033 16.7307C9.56699 16.2141 10.3837 16.1641 10.9587 16.6057L12.3753 17.6641C12.467 17.7307 12.5503 17.7057 12.592 17.6807C12.6337 17.6557 12.7087 17.6057 12.7087 17.4974V3.33073C12.7087 2.95573 12.8003 2.5974 12.9587 2.28906H5.00033C3.15033 2.28906 2.29199 3.1474 2.29199 4.9974V17.4974C2.29199 17.6141 2.36699 17.6641 2.40866 17.6891C2.45866 17.7141 2.54199 17.7307 2.62533 17.6641L4.05033 16.5974C4.30866 16.4057 4.61699 16.3057 4.92533 16.3057Z"
        fill="#1678F2"
      />
      <path
        d="M10 11.4688H7.5C7.15833 11.4688 6.875 11.1854 6.875 10.8438C6.875 10.5021 7.15833 10.2188 7.5 10.2188H10C10.3417 10.2188 10.625 10.5021 10.625 10.8438C10.625 11.1854 10.3417 11.4688 10 11.4688Z"
        fill="#1678F2"
      />
      <path
        d="M10 8.13281H7.5C7.15833 8.13281 6.875 7.84948 6.875 7.50781C6.875 7.16615 7.15833 6.88281 7.5 6.88281H10C10.3417 6.88281 10.625 7.16615 10.625 7.50781C10.625 7.84948 10.3417 8.13281 10 8.13281Z"
        fill="#1678F2"
      />
      <path
        d="M4.97493 8.33854C4.5166 8.33854 4.1416 7.96354 4.1416 7.50521C4.1416 7.04687 4.5166 6.67188 4.97493 6.67188C5.43327 6.67188 5.80827 7.04687 5.80827 7.50521C5.80827 7.96354 5.43327 8.33854 4.97493 8.33854Z"
        fill="#1678F2"
      />
      <path
        d="M4.97493 11.6745C4.5166 11.6745 4.1416 11.2995 4.1416 10.8411C4.1416 10.3828 4.5166 10.0078 4.97493 10.0078C5.43327 10.0078 5.80827 10.3828 5.80827 10.8411C5.80827 11.2995 5.43327 11.6745 4.97493 11.6745Z"
        fill="#1678F2"
      />
    </svg>
  );
};

export default SubscriptionIcon;
